import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';

// This component simply renders its children.
// The HOC handles the redirect logic.
const ProtectedRoute = ({ component, ...args }) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};

export default ProtectedRoute; 